<div class="flex-vertical width-100pc gap-16">
  <oui-select
    label="Comment ont été signés les documents du partenaire ? (hors documents Stellium)"
    [control]="signatureControl"
    [options]="signatureOptions"
  class="width-100pc"></oui-select>

  @if (
    signatureControl.value === 'ELECTRONIQUE_ARIANE_UNIVERSIGN' &&
    this.operation?.operationConfig?.enveloppeProduit?.code === enveloppeFondsUsufruitCode
    ) {
    <oui-banner
      title="Le bulletin de souscription doit être envoyé obligatoirement et uniquement par le client à l’adresse e-mail esouscription.psi@stellium.fr."
      declination="alert"
    [showCloseButton]="false"></oui-banner>
  }

  @if (
    signatureControl.value === 'MANUSCRITE' &&
    this.operation?.operationConfig?.enveloppeProduit?.code === enveloppeFondsUsufruitCode
    ) {
    <oui-banner
      title="Le bulletin de souscription doit être envoyé obligatoirement et uniquement par le client par courrier à l’adresse : Stellium Invest PSI – 11 avenue Parmentier, 31201 Toulouse, Cedex 2"
      declination="alert"
    [showCloseButton]="false"></oui-banner>
  }

  @if (
    showTransmissionField &&
    (this.operation?.operationConfig?.enveloppeProduit?.code !== enveloppeFondsUsufruitCode ||
    signatureControl.value !== 'MANUSCRITE')
    ) {
    <oui-select
      label="Transmission des originaux"
      [control]="transmissionControl"
      [options]="transmissionListOptions"
    class="width-100pc"></oui-select>
  }

  @if (transmissionControl.value === 'envoiPostal') {
    <oui-banner
      title="Votre opération sera traitée dès la réception des documents originaux que vous devez également déposer en version numérique à l'étape suivante."
      declination="alert"
    [showCloseButton]="false"></oui-banner>
  }

  @if (transmissionControl.value === 'pasEnvoiPostal') {
    <oui-banner
      title="Vous devez déposer tous les documents en version numérique à l'étape suivante."
      declination="alert"
    [showCloseButton]="false"></oui-banner>
  }
</div>
